export default "__VITE_ASSET__c4027210__"